var $3c9af509a01a8d08$exports = {};
$3c9af509a01a8d08$exports = {
    "(optional)": `(\u{3C0}\u{3C1}\u{3BF}\u{3B1}\u{3B9}\u{3C1}\u{3B5}\u{3C4}\u{3B9}\u{3BA}\u{3CC})`,
    "(required)": `(\u{3B1}\u{3C0}\u{3B1}\u{3B9}\u{3C4}\u{3B5}\u{3AF}\u{3C4}\u{3B1}\u{3B9})`
};


export {$3c9af509a01a8d08$exports as default};
//# sourceMappingURL=el-GR.module.js.map
